import { render, staticRenderFns } from "./materialNumList.vue?vue&type=template&id=f54834be&scoped=true&"
import script from "./materialNumList.vue?vue&type=script&lang=js&"
export * from "./materialNumList.vue?vue&type=script&lang=js&"
import style0 from "./materialNumList.vue?vue&type=style&index=0&id=f54834be&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f54834be",
  null
  
)

export default component.exports